import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-phone-input-2/lib/style.css'; // Import library CSS FIRST
import './styles/App.css'; // Then our custom CSS
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);